import React from 'react'
// import { FaRegUserCircle } from 'react-icons/fa'
// import { MdOutlineLocationOn, MdUpdate } from 'react-icons/md'
// import { useLocation, useNavigate } from 'react-router-dom';

function DetailSection({title, icon: Icon, fields = [], showEdit = false, onEdit, extraActions = null}) {


  return (
    <>
    <div className="section">
              {/* Edit Button (optional) */}
                {(showEdit || extraActions) && (
                  <div className="edit-btn-wrap" style={{ display: "flex", gap: 8, alignItems: "center" }}>
                    {showEdit && (
                      <button className="edit-btn" onClick={onEdit}>Edit</button>
                    )}
                    {extraActions}
                  </div>
                )}
              {/* Title & Icon */}
                <h3>
                    {Icon && <Icon />} {title}
                </h3>
                
                {/* Dynamic fields */}
                <div className="section-content">
                    {fields.map((item, index) => (
                    <p key={index}>
                        <strong>{item.label}:</strong> {item.value ?? "N/A"}
                    </p>
                    ))}
                </div>
            </div>
        </>
  )
}

export default DetailSection